// extracted by mini-css-extract-plugin
export var emptyState = "_78-d";
export var statCard = "_78-c";
export var table = "_78-0";
export var tableCell = "_78-4";
export var tableCellClickable = "_78-5 _78-4";
export var tableCellDefault = "_78-6 _78-4";
export var tableCellEmpty = "_78-8";
export var tableCellWithValue = "_78-7";
export var tableContainer = "_78-e";
export var tableHeaderWeight = "_78-1";
export var tableHeaderZone = "_78-2";
export var tableRowHeader = "_78-3";
export var viewModeButton = "_78-9";
export var viewModeButtonActive = "_78-a _78-9";
export var viewModeButtonInactive = "_78-b _78-9";